const initialState = { 
  loading: false,
  success: null,
  error: null
}

function rejectTransactionReducer(state = initialState, action) {
  switch (action.type) {
    case 'REJECT_TRANSACTION_DROPSHIPPING_BEGIN':
      return {
        ...state,
        loading: true,
        success: null,
        error: null
      }

    case 'REJECT_TRANSACTION_DROPSHIPPING_SUCCESS':
      return {
        ...state,
        loading: false,
        success: action.success
      }

    case 'REJECT_TRANSACTION_DROPSHIPPING_FAILURE':
      return {
        ...state,
        loading: false,
        error: action.error
      }

    default: return state
  }
}

export default rejectTransactionReducer
